import { getUserInfo } from "@/api/services/userService";
import { TwoFA } from "@/components/TwoFA/useTowFA";
import { useLoginStateContext } from "@/pages/sys/login/providers/login-provider";
import { useRouter } from "@/routes/hooks";
import { useUserActions, useUserInfo } from "@/store/userStore";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@/ui/dropdown-menu";
import { useRequest } from "ahooks";
import { Alert } from "antd";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

/**
 * Account Dropdown
 */
export default function AccountDropdown() {
	const { replace } = useRouter();
	const { username } = useUserInfo();
	const { clearUserInfoAndToken } = useUserActions();
	const { backToLogin } = useLoginStateContext();
	const { t } = useTranslation();
	const logout = () => {
		try {
			clearUserInfoAndToken();
			backToLogin();
		} catch (error) {
			console.log(error);
		} finally {
			replace("/auth/login");
		}
	};
	
	const resetPassword = () => {
		try {
			replace('/auth/reset-password');
		} catch (error) {
			console.log(error);
		}
	}

	const { bindMfaStatus } = useUserInfo();

	const tfaRef = useRef<{
    setEmailOpen: (v: boolean) => void;
    setDisTFAOpen: (v: boolean) => void;
  }>(null);

	const setMfa = () => {
		bindMfaStatus ? tfaRef.current?.setDisTFAOpen(true) : tfaRef.current?.setEmailOpen(true);
	}

	return (
		<>
			<DropdownMenu>
				<div className="flex items-center gap-6">
					{
						!bindMfaStatus &&  <Alert
							message={<div>
							For account security, please set up your 2FA &nbsp;
							<span
								onClick={() => tfaRef.current?.setEmailOpen(true)}
								className="text-warning cursor-pointer"
							>
								Go Set up
							</span>
						</div>} banner />
					}
					<DropdownMenuTrigger>
						<div className="w-10 h-10 rounded-full bg-primary text-center pt-2 text-xl color">{username?.slice(1, 2).toUpperCase()}</div>
					</DropdownMenuTrigger>
				</div>
				<DropdownMenuContent className="w-56">
					<div className="flex items-center gap-2 p-2">
						<div className="w-8 h-8 rounded-full bg-primary text-center align-center pt-1">{username?.slice(1, 2).toUpperCase()}</div>
						<div className="flex flex-col items-start">
							<div className="text-text-primary text-sm font-medium ml-2">{username}</div>
						</div>
					</div>
					<DropdownMenuSeparator />
					<DropdownMenuItem className="cursor-pointer border-b" onClick={setMfa}>
						{ bindMfaStatus ? 'Disabled Mfa' : 'Bind Mfa' }
					</DropdownMenuItem>
					<DropdownMenuItem className="cursor-pointer border-b" onClick={resetPassword}>
						Reset Password
					</DropdownMenuItem>
					<DropdownMenuItem className="font-bold text-warning cursor-pointer" onClick={logout}>
						Logout
					</DropdownMenuItem>
				</DropdownMenuContent>
			</DropdownMenu>
			<TwoFA ref={tfaRef} />
		</>
	);
}
